/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type FC } from 'react';

import { I18n } from '@coze-arch/i18n';
import { IconCozPlus } from '@coze-arch/coze-design/icons';

import styles from './hero-create-agent-bento.module.less';

export interface HeroCreateAgentBentoProps {
  onClick: () => void;
}

export const HeroCreateAgentBento: FC<HeroCreateAgentBentoProps> = ({
  onClick,
}) => (
  <button
    type="button"
    className={styles.bento}
    onClick={onClick}
    data-testid="abr-create-agent-hero"
  >
    <span className={styles.shine} aria-hidden />
    <span className={styles.icon} aria-hidden>
      <IconCozPlus />
    </span>
    <span className={styles.label}>{I18n.t('abr_shell_create_agent')}</span>
  </button>
);
